import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading || user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA]" data-testid="protected-loading">
                <Loader2 className="w-6 h-6 animate-spin text-slate-500" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
